import { Outlet, Navigate } from "react-router-dom";
import { auth } from "../../lib/api";
import Sidebar from "../../components/app/Sidebar";
import Topbar from "../../components/app/Topbar";
import { WSProvider } from "../../lib/ws-context";

export default function AppLayout() {
  if (!auth.isAuthed()) {
    return <Navigate to="/login" replace />;
  }
  return (
    <WSProvider>
      <div className="min-h-screen flex bg-background text-foreground">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <Topbar />
          <main data-testid="app-main"
                className="flex-1 px-4 md:px-10 py-8 max-w-[1400px] w-full mx-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </WSProvider>
  );
}
